import { useAuth0 } from '@auth0/auth0-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AuthedApp from './AuthedApp';
import { queryClient } from './components/dashboards/lib/queryClient';
import VenueMapPage from './components/venues/VenueMapPage';
import { configureAuth } from './lib/apiFetch';
import AuthErrorPage from './shared/AuthErrorPage';

function App() {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    configureAuth(() =>
      getAccessTokenSilently({
        authorizationParams: { audience: import.meta.env.VITE_AUTH0_AUDIENCE },
      }),
    );
  }, [getAccessTokenSilently]);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          {/* Public routes — no auth, no chrome */}
          <Route path="/locations" element={<VenueMapPage />} />
          <Route path="/error" element={<AuthErrorPage />} />

          {/* Everything else lives inside the app shell, behind the auth gate
              and the app-wide toast provider (see AuthedApp). */}
          <Route path="*" element={<AuthedApp />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
